export class NaverAuth {
  clientId: string;
  clientSecret: string;
  callbackURL: string;
  naverLogin: any;

  constructor(clientId: string, clientSecret: string, callbackURL: string) {
    this.clientId = clientId;
    this.clientSecret = clientSecret;
    this.callbackURL = callbackURL;
  }

  /**
   * Creates a hidden button for Naver SDK, as it wil throw errors if the button doesn't exist
   * @returns HTMLDivElement
   */
  createButton() {
    const div = document.createElement('div');
    div.id = NaverAuth.buttonId;
    div.setAttribute('style', 'position: absolute; top: -10000px; display: none;');
    return div;
  }

  createScriptTag() {
    const script = document.createElement('script');
    script.id = NaverAuth.scriptId;
    script.src = NaverAuth.scriptSrc;
    script.defer = true;
    script.async = true;
    script.onload = () => {
      const naver = (window as any).naver;
      if (!naver) {
        throw new Error('Error: naver script is not installed properly');
      }

      this.naverLogin = new naver.LoginWithNaverId({
        callbackUrl: this.callbackURL,
        clientId: this.clientId,
        isPopup: false,
        loginButton: { color: 'green', type: 3, height: 60 },
      });

      this.naverLogin.init();
    };
    return script;
  }

  generateLogoutUrl(token: string) {
    return `https://nid.naver.com/oauth2.0/token?grant_type=delete&client_id=${this.clientId}&client_secret=${this.clientSecret}&access_token=${token}&service_provider=NAVER`;
  }

  userLogin() {
    window.location.assign(this.naverLogin.generateAuthorizeUrl());
  }

  static get naverQueryParams() {
    return ['access_token', 'state', 'token_type', 'expires_in'];
  }

  static get scriptSrc() {
    return 'https://static.nid.naver.com/js/naveridlogin_js_sdk_2.0.2.js';
  }

  static get scriptId() {
    return 'naver-login-sdk';
  }

  static get buttonId() {
    return 'naverIdLogin';
  }
}
